import { render, staticRenderFns } from "./giveVIpDialog.vue?vue&type=template&id=2d939260"
import script from "./giveVIpDialog.vue?vue&type=script&lang=js"
export * from "./giveVIpDialog.vue?vue&type=script&lang=js"
import style0 from "./giveVIpDialog.vue?vue&type=style&index=0&id=2d939260&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports